var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function CursorsPointerIconInner(props) {
    return (React.createElement("svg", __assign({ width: 18, height: 23, viewBox: "0 0 18 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { filter: "url(#filter0_d_4494_22213)" },
            React.createElement("path", { d: "M4 17V2H5V3H6V4H7V5H8V6H9V7H10V8H11V9H12V10H13V11H14V12H15V13H11V14H12V16H13V18H12V19H10V18H9V16H8V14H7V15H6V16H5V17H4Z", fill: "white" })),
        React.createElement("path", { d: "M6 4H5V15H6V14H7V13H8V14H9V16H10V18H12V16H11V14H10V12H13V11H12V10H11V9H10V8H9V7H8V6H7V5H6V4Z", fill: "" }),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d_4494_22213", x: 1, y: 0, width: 17, height: 23, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: 1 }),
                React.createElement("feGaussianBlur", { stdDeviation: 1.5 }),
                React.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
                React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" }),
                React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_4494_22213" }),
                React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_4494_22213", result: "shape" })))));
}
export var CursorsPointerIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: CursorsPointerIconInner }, props))); };
//# sourceMappingURL=CursorsPointerIcon.js.map